'use strict';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';

import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import { UiSwitchModule } from 'ng2-ui-switch'

import { AppComponent } from './app.component';
import { NavbarModule } from './modules/shared/navbar/navbar.module';
import { SidebarModule } from './modules/shared/sidebar/sidebar.module';
import { AuthService } from './services/auth/auth.service';
import { AuthGuard } from './guards/auth/auth.guard';

import { ApiService } from './services/api.service';
import { LoginComponent } from './components/login/login.component';
import { CreateAccountComponent } from './components/create-account/create-account.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { HomeComponent } from './components/home/home.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { AddCompanyComponent } from './components/add-company/add-company.component';
import { UpdateCompanyComponent } from './components/update-company/update-company.component';
import { LogoutComponent } from './components/logout/logout.component';
import { SearchPipe } from './pipes/search.pipe';
import { CpasswordComponent } from './components/cpassword/cpassword.component';
import { ImportComponent } from './components/import/import.component';
import { BillingComponent } from './components/billing/billing.component';
import { MyDatePickerModule } from 'mydatepicker';
import { SystemAnalyticsComponent } from './components/Systemanalytics/system-analytics.component';
import { InfiniteScrollModule } from 'angular2-infinite-scroll';
import { AppversionComponent } from './components/appversion/appversion.component';
import { OnboardingTutorialComponent } from './components/onboarding-tutorial/onboarding-tutorial.component';
import { BoardingVideosListComponent } from './components/boarding-videos-list/boarding-videos-list.component';
import { DragDirective } from '../dragDrop.directive';
import { ButtonsModule } from 'ngx-bootstrap';
import { ActivityLogComponent } from './components/activity-log/activity-log.component';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { HttpClientModule} from '@angular/common/http';


@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		CreateAccountComponent,
		ForgotPasswordComponent,
		HomeComponent,
		ChangePasswordComponent,
		AddCompanyComponent,
		UpdateCompanyComponent,
		LogoutComponent,
		SearchPipe,
		CpasswordComponent,
		ImportComponent,
		BillingComponent,
		SystemAnalyticsComponent,
        AppversionComponent,
        OnboardingTutorialComponent,
        BoardingVideosListComponent,
		ActivityLogComponent,
		DragDirective
	],
	imports: [
    	BrowserModule,
		
		FormsModule,
		ReactiveFormsModule,
		NavbarModule,
		SidebarModule,
		BrowserAnimationsModule,
		ToasterModule,
		UiSwitchModule,
		MyDatePickerModule,
		InfiniteScrollModule,
		ButtonsModule,
		MyDateRangePickerModule,
		NgxJsonViewerModule,
		HttpClientModule,
		RouterModule.forRoot([
			{
				path: '',
				redirectTo: '/login',
				pathMatch: 'full'
			},
			{ path: 'login', component: LoginComponent },
			// { path : '\signup',            component : CreateAccountComponent },
			{ path: '\logout', component: LogoutComponent },
			{ path: 'forgotpassword', component: ForgotPasswordComponent },
			{ path: 'changepassword', component: ChangePasswordComponent },
			{ path: '\home', component: HomeComponent, canActivate: [AuthGuard], pathMatch: 'full' },
			{ path: 'import', component: ImportComponent, canActivate: [AuthGuard], pathMatch: 'full' },
			{ path: 'addcompany', component: AddCompanyComponent, canActivate: [AuthGuard], pathMatch: 'full' },
			{ path: 'updatecompany', component: UpdateCompanyComponent, canActivate: [AuthGuard], pathMatch: 'full' },
			{ path: 'cpassword', component: CpasswordComponent, canActivate: [AuthGuard], pathMatch: 'full' },
			{ path: 'billing/:id/:startDate/:endDate', component: BillingComponent, canActivate: [AuthGuard], pathMatch: 'full' },
			{ path: 'systemanalytics', component: SystemAnalyticsComponent, canActivate: [AuthGuard], pathMatch: 'full' },
            { path: 'appversion', component: AppversionComponent, canActivate: [AuthGuard], pathMatch: 'full' },
			{ path: 'onboarding-tutorial', component:OnboardingTutorialComponent,  canActivate: [AuthGuard], pathMatch: 'full'},
			{ path: 'videosList', component:BoardingVideosListComponent,  canActivate: [AuthGuard], pathMatch: 'full'},
			{ path: 'ActivityLog', component: ActivityLogComponent, canActivate: [AuthGuard], pathMatch: 'full' },
		])
	],
	providers: [ApiService, AuthGuard, AuthService],
	bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts